import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import analytics from 'helpers/analytics';
import { redirectTo } from 'helpers/history';

import { authSuccess } from 'store/modules/auth';
import { getUserProfile } from 'store/modules/profile';

import api from 'api';

import { signIn } from './signIn';

export interface ConfirmationState {
  isLoading: boolean;
  success: boolean;
  password: string;
  passwordConfirmation: string;
  error: AxiosError | null;
}

export const initialConfirmationState: ConfirmationState = {
  isLoading: false,
  success: false,
  password: '',
  passwordConfirmation: '',
  error: null,
};

const confirmationSlice = createSlice({
  name: 'confirmation',
  initialState: initialConfirmationState,
  reducers: {
    confirmationLoading: (state) => {
      state.isLoading = true;
      state.success = false;
    },
    confirmationSuccess: (state) => {
      state.success = true;
      state.isLoading = false;
    },
    confirmationError: (state, action: PayloadAction<AxiosError>) => {
      state.success = false;
      state.isLoading = false;
      state.error = action.payload;
    },
    updatePassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    updatePasswordConfirmation: (state, action: PayloadAction<string>) => {
      state.passwordConfirmation = action.payload;
    },
  },
});

export const {
  confirmationLoading,
  confirmationSuccess,
  confirmationError,
  updatePassword,
  updatePasswordConfirmation,
} = confirmationSlice.actions;

export function signUpConfirmation(
  credentials: { password?: string },
  currentUrl: string,
) {
  return (dispatch) => {
    dispatch(confirmationLoading());

    return api.auth
      .signUpConfirmation(credentials)
      .then((res) => {
        analytics.track('sign-up', {
          category: 'user',
        });

        if (credentials.password) {
          dispatch(
            signIn({
              email: res.data.user.email,
              password: credentials.password,
              rememberMe: false,
            }),
          ).then(() => {
            redirectTo(currentUrl, 'browse');
          });
        } else {
          dispatch(authSuccess());
          dispatch(getUserProfile());
        }
        dispatch(confirmationSuccess());
      })
      .catch((err) => {
        dispatch(confirmationError(err));
      });
  };
}

export default confirmationSlice.reducer;
